if (customElements.get("content-drawer") === undefined) {
    class contentDrawer extends HTMLElement {
        // eslint-disable-next-line no-useless-constructor
        constructor() {
            super();
            this.open = this.open.bind(this);
            this.close = this.close.bind(this);
        }

        connectedCallback() {
            if (this.dataset.overlay) {
                this._addOverlay(this.dataset.overlay);
            }

            this._addDisplayClasses();
            this._bindCloseElement();

            this.openEvent = `${this.dataset.drawer_id}:open`;
            this.closeEvent = `${this.dataset.drawer_id}:close`;

            document.addEventListener(this.openEvent, this.open);
            document.addEventListener(this.closeEvent, this.close);
        }

        open() {
            this.classList.add("content-drawer--open");
        }

        close() {
            this.classList.remove("content-drawer--open");
        }

        _bindCloseElement() {
            const closeElements = this.querySelectorAll(
                ".js-content-drawer-close",
            );
            if (closeElements) {
                closeElements.forEach((closeElement) =>
                    closeElement.addEventListener("click", this.close, false),
                );
            }
        }

        _addDisplayClasses() {
            if (this.dataset.open_from)
                this.classList.add(
                    `content-drawer--from-${this.dataset.open_from}`,
                );
            // eslint-disable-next-line eqeqeq
            if (this.dataset.full_height && this.dataset.full_height != "false")
                this.classList.add("content-drawer--full-height");
            this.classList.remove("content-drawer--loading");
        }

        _addOverlay(color) {
            const overlay = document.createElement("div");
            overlay.classList.add("overlay");
            overlay.style.backgroundColor = color;
            overlay.onclick = this.close;
            this.insertBefore(overlay, this.firstChild);
        }
    }

    customElements.define("content-drawer", contentDrawer);
}
